import React from 'react';
import cn from 'classnames';
import {Link} from 'react-router';
import Button from '@material-ui/core/Button';
import './NotFoundPage.styl';
import {CoachLogo} from '@components/logo/CoachLogo';

interface LinkType {
  link: string;
  title: string;
}

const DEF_GO_BACK: LinkType = {
  link: '/',
  title: 'Go back home',
};

interface Props {
  title?: string;
  subtitle?: string;
  goBackLink?: false | LinkType;
  withHeader?: boolean;
}

export const NotFoundPage: React.FC<Props> = ({
  title = '404',
  subtitle = 'Not found',
  children = 'We cannot find the page that you were looking for.',
  goBackLink = DEF_GO_BACK,
  withHeader = true,
}) => {
  return (
    <div className={cn('not-found-page', {'not-found-page-without-header': !withHeader})}>
      {withHeader && (
        <nav className="navbar">
          <div className="left">
            <CoachLogo />
          </div>
          <div className="right">
            <Button
              component="a"
              variant="outlined"
              className="learn-more"
              href="https://support.mediafly.com/hc/en-us"
              target="_blank"
              rel="noreferrer">
              Learn More
            </Button>
          </div>
        </nav>
      )}
      <div className="main">
        {Boolean(title) && <h2 className="title">{title}</h2>}
        <h3 className="subtitle">{subtitle}</h3>
        <p className="text">{children}</p>
        <div className="not-found-image" />
        {goBackLink && (
          <Button
            variant="contained"
            color="primary"
            size="large"
            component={Link}
            to={goBackLink.link}
            className="ev-button">
            {goBackLink.title}
          </Button>
        )}
      </div>
    </div>
  );
};
